import { IThirdPartyUserClientZoneAssignmentZoneInfoDTO } from "src/app/base/models/models.swagger.generated";

export class ZonePathUtil {
  public static readonly extendedZonePathFieldName = 'zonePath';

  public static extendByZonePath(zoneInfo: IThirdPartyUserClientZoneAssignmentZoneInfoDTO): IThirdPartyUserClientZoneAssignmentZoneInfoDTO {
    if (!zoneInfo) {
      return null;
    }
    const extendedZoneInfo = zoneInfo as any;
    extendedZoneInfo[ZonePathUtil.extendedZonePathFieldName] = ZonePathUtil.getZonePath(zoneInfo);
    return extendedZoneInfo;
  }

  public static getZonePath(zone: IThirdPartyUserClientZoneAssignmentZoneInfoDTO): string {
    if (!zone) {
      return null;
    }
    return [zone.grandGrandParentName, zone.grandParentName, zone.parentName, zone.name].filter(Boolean).join(' / ');
  }
}
